import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Box, Image } from "rebass";
import { template } from "../dataTemplate";

class TemplateItem extends Component {
  onClickSave = items => {
    this.props.onUpdateData(items.content);
  };

  render() {
    return (
      <div style={{ overflowY: "scroll", height: 500, width: "100%" }}>
        <Box w={[1]}>
          {template.map((item, index) => {
            return (
              <Box w={[1]} key={index} p={[1]}>
                <ButtonBox onClick={this.onClickSave.bind(this, item)}>
                  <BoxImage src={item.thumbnail} alt={item.title} />
                </ButtonBox>
              </Box>
            );
          })}
        </Box>
      </div>
    );
  }
}

const BoxImage = Image.extend`
  background-color: #ffffff;
`;

const ButtonBox = styled.div`
  padding: 1px;
  background-color: #173f4f;
  cursor: pointer;
  &:hover {
    background-color: #ff9900;
  }
`;

TemplateItem.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func
};

TemplateItem.defaultProps = {
  data: {}
};

export default TemplateItem;



// WEBPACK FOOTER //
// ./src/editor/layout/catalog/TemplateItem.js